import { useEffect } from 'react';
import { useAppContext, APP_PAGE_STORAGE_KEY } from '../../../contexts/AppContext';
import { useAuth } from '../../../contexts/AuthContext';
import { isPartnerShellPage } from '../../../utils/routeUtils';
import { useIsPartner } from './useIsPartner';

/**
 * Keeps non-partners off partner shell routes (deep links, localStorage restore).
 * Backend remains source of truth — this is UX only.
 */
export function usePartnerPageGuard(): void {
  const { currentPage, setCurrentPage } = useAppContext();
  const { isAuthLoading } = useAuth();
  const { isPartner, isLoading: isPartnerLoading, loadFailed } = useIsPartner();

  useEffect(() => {
    if (isAuthLoading || isPartnerLoading) return;
    if (isPartner || !isPartnerShellPage(currentPage)) return;
    // Network/RLS error ≠ "not a partner". Kicking to dashboard was blocking real partners.
    if (loadFailed) return;

    setCurrentPage('dashboard');
    try {
      localStorage.setItem(APP_PAGE_STORAGE_KEY, 'dashboard');
    } catch {
      /* ignore quota errors */
    }
  }, [currentPage, isPartner, isAuthLoading, isPartnerLoading, loadFailed, setCurrentPage]);
}
